import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { I18nModule } from '@app/i18n';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login.component';
import { LoginModalComponent } from './login-modal.component';
import { RegisterComponent } from './register/register.component';
import { SharedModule } from '@app/@shared';
import { RecoveryComponent } from './recovery/recovery.component';
import { NotAlowedComponent } from './noAlowed/not-alowed/not-alowed.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    IonicModule,
    I18nModule,
    AuthRoutingModule,
    SharedModule,
  ],
  declarations: [LoginComponent, LoginModalComponent, RegisterComponent, RecoveryComponent, NotAlowedComponent],
  exports: [NotAlowedComponent, LoginModalComponent],
})
export class AuthModule {}
